import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AuthProvider } from '@/context/AuthContext';
import { ThemeProvider } from '@/context/ThemeContext';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { registerServiceWorker } from '@/lib/registerServiceWorker';
import { runtimeConfig } from '@/runtimeConfig';

ModuleRegistry.registerModules([AllCommunityModule]);

async function bootstrap() {
  const licenseKey =
    runtimeConfig?.agGridLicenseKey ||
    import.meta.env.VITE_AG_GRID_LICENSE_KEY ||
    import.meta.env.AG_GRID_LICENSE_KEY;

  if (licenseKey) {
    const { AllEnterpriseModule, LicenseManager } = await import('ag-grid-enterprise');
    LicenseManager.setLicenseKey(licenseKey);
    ModuleRegistry.registerModules([AllEnterpriseModule]);
  }

  const queryClient = new QueryClient();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <ThemeProvider>
              <App />
            </ThemeProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  );

  registerServiceWorker();
}

void bootstrap();
